export default __webpack_public_path__ + "static/media/idea.94403e38.gif";